// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buy-item-container[data-v-8ff4d8e4]{position:relative;min-height:100%}.active-migration-disclaimer[data-v-8ff4d8e4]{background:#ebac1e;border:2px solid #d07022}.active-migration-disclaimer img[data-v-8ff4d8e4]{width:24px}", ""]);
// Exports
module.exports = exports;
